import React, { useMemo } from "react";
import { connect } from "react-redux";
import {
  Layout,
  Button,
  Row,
  Col,
  Modal,
  Form,
  Spin,
  Typography,
  notification,
  message,
  Upload,
  Radio,
  Input,
  Tooltip,
} from "antd";
import { Header, AutoCompleteCompany, TableForm } from "components";
import { CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined, MinusCircleOutlined, SaveOutlined, UploadOutlined } from "@ant-design/icons";
import {
  generateTemplateExcel,
  validateCpf,
  formatDate,
  formatCpf,
  replacePhone,
  emptyValue,
  saveFileResume,
} from "utils";
import { getAllEmployees } from "services/employee-service";
import { saveUserBatch, savePasswordUser, savePreRegisterUserBatch, deletePreRegisterUserBatch, sendFirstAccessNotification, getAllOccupationV2 } from "services/user-service";
import { getCompany } from "services/company-service";
import moment from "moment";
import CheckboxMenu from "components/button/checkbox-menu";
import pLimit from "p-limit";
import useHttpGeo from "hooks/use-http-geo";
import { read, utils, writeFile } from "xlsx";
import { themeColors } from "theme";
import { useNavigate } from "react-router-dom";
import Search from "antd/es/input/Search";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { MONTHLY_REVENUE_RANGE_DATA } from "utils/static-data";

const { Dragger } = Upload;
const { Footer, Content } = Layout;

const mapStateToProps = (state) => ({
  login: state.authReducer.loginReducer,
});

const DataFetch = {
  data: [],
  dataTable: [],
  header: [
    {
      title: "Nome",
      key: "name",
    },
    {
      title: "E-mail",
      key: "email",
    },
    {
      title: "CPF",
      key: "cpf",
    },
    {
      title: "Nascimento",
      key: "birthday",
    },
    {
      title: "Telefone",
      key: "phone",
    },
    {
      title: "Sexo (M/F)",
      key: "sex",
    },
    {
      title: "Rua",
      key: "address",
    },
    {
      title: "Número",
      key: "number",
    },
    {
      title: "Complemento",
      key: "complement",
    },
    {
      title: "Bairro",
      key: "neighborhood",
    },
    {
      title: "CEP",
      key: "zipcode",
    },
    {
      title: "Cidade",
      key: "city",
    },
    {
      title: "Estado",
      key: "state",
    },
    {
      title: "País (BRA)",
      key: "country"
    },
    {
      title: "Ocupação",
      key: "occupation"
    },
    {
      title: "Faixa de renda Mensal",
      key: "monthlyRevenueRange"
    }
  ],
  fields: [
    "name",
    "email",
    "cpf",
    "birthday",
    "phone",
    "sex",
    "address",
    "number",
    "complement",
    "neighborhood",
    "zipcode",
    "city",
    "state",
    "country",
    "occupation",
    "monthlyRevenueRange"
  ],
  filter: {
    cpf: (value) => (value ? validateCpf(value.trim()) : ""),
    birthday: (value) => {
      return value ? moment(value).format("DD/MM/YYYY") : "";
    },
    sex: (value) => {
      if (!value) {
        return "";
      }
      let val = value
        .replace(/\n/g, "")
        .replace(/\t/g, " ")
        .replace(/\t/g, "")
        .replace(/ /g, "");
      return val === "M" || val === "F" ? val : "";
    },
  },
};


const REGISTER = 'register';
const PRE_REGISTER = 'pre-register';
const SAVING_STATUS = 'saving';
const NOT_CHANGES_STATUS = 'notChanges';
const SUCCESS_STATUS = 'success';
const ERROR_STATUS = 'error';


const UserBatchScreen = (props) => {
  const { login } = props;
  const [data, setData] = React.useState(DataFetch);
  const [company, setCompany] = React.useState(null);
  const [companyData, setCompanyData] = React.useState(null);
  const [importShow, setImportShow] = React.useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  const [pagination, setPagination] = React.useState({ current: 1, pageSize: 10 });
  const [saving, setSaving] = React.useState(false);
  const [passwordShow, setPasswordShow] = React.useState(false);
  const [validateFields, setValidateFields] = React.useState(false);
  const [formImport] = Form.useForm();
  const [saveData, setSaveData] = React.useState(false);
  const [form] = Form.useForm();
  const [searchForm] = Form.useForm();
  const httpGeo = useHttpGeo();
  const [option, setOption] = React.useState(REGISTER);
  const [tableData, setTableData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [showDelete, setShowDelete] = React.useState(false);
	const [showFirstAccessNotification, setShowFirstAccessNotification] = React.useState(false);
  const [filterRegister, setFilterRegister] = React.useState([]);
  const [filterPreRegister, setFilterPreRegister] = React.useState([]);
  const navigate = useNavigate();
  const [occupations, setOccupations] = React.useState([]);
  const [visibleFields, setVisibleFields] = React.useState([
    ...DataFetch.fields.filter(
      (v) =>
        v != "cpf" &&
        v != "number" &&
        v != "complement" &&
        v != "neighborhood" &&
        v != "zipcode" &&
        v != "city" &&
        v != "state"
    ),
    "card",
    "enabled",
  ]);
  const linkStyle = {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'underline',
    display: 'inline',
    margin: 0,
    padding: 0,
    color: themeColors.blueColor
  };

  const formatDataTable = (lines, dataList, edited) => {
    let list = lines.map((user, index) => {
      let find = dataList
        ? dataList.filter((_user) => _user.email == user.email || _user.cpf == user.cpf)
        : [];
      let enabled = true;
      let card = false;
      let line = true;
      if (find.length > 0) {
        let item = find[0];
        enabled = item.enabled;
        card = item.card;
        line = false;
      }
      user.key = index;
      user.enabled = enabled;
      user.edited = edited == true;
      user.card = card;
      user.line = line;
      user.phone = user.phone && user.phone != "" ? user.phone : "";
      user.sex = user.sex && user.sex != "null" ? user.sex : null;
      return user;
    });
    return list;
  };

  const PRE_REGISTER_HEADERS = useMemo(() => {
    const _columns = [
      {
        title: "Nome",
        key: "name",
      },
      {
        title: "E-mail",
        key: "email",
      },
      {
        title: "CPF",
        key: "cpf",
      },
      {
        title: 'Telefone',
        key: 'phone',
      },
      {
        title: "Campanha / CNPJ",
        key: "campaign",
      },
      {
        title: "Corporativo (S/N)",
        key: "autoIssueCorporateCard",
      },
    ];

    return _columns;
  }, []);

  const filterFieldsSelected = (d) => {
    if (d == "cpf") return true;
    else if (
      visibleFields.includes("address") &&
      (d == "address" ||
        d == "number" ||
        d == "complement" ||
        d == "neighborhood" ||
        d == "zipcode" ||
        d == "city" ||
        d == "state")
    ) {
      return true;
    } else if (d != "address" && visibleFields.includes(d)) {
      return true;
    }
    return false;
  };

  const formatRealDate = (dateString) => {
    try {
      if (typeof dateString == 'string') {
        const dateParts = dateString.split("/");
        return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      }
    } catch (e) {
      return dateString;
    }

    return dateString;
  };

  const onUploadSheet = async (file) => {
    try {
      setImportShow(false);
      setSaveData(false);
      setData((data) => ({ ...data, dataTable: [] }));
      setLoading(true);

      const fileBuffer = await file.arrayBuffer();
      const workBook = read(fileBuffer, {
        cellDates: true
      });
      const workSheet = workBook.Sheets[workBook.SheetNames[0]];
      const uploadLines = utils.sheet_to_json(workSheet,
        {
          header: data.header.map(header => header.key),
        }
      );
      uploadLines.shift();

      uploadLines.forEach(line => {
        line.birthday = formatRealDate(line.birthday);
        line.cpf = formatCpfMask(line.cpf.toString().length < 11 ? line.cpf.toString().padStart(11, '0') : line.cpf.toString());
        const phoneOnlyDigits = line.phone ? line.phone.toString().replace(/\D/g, '') : '';
        if (phoneOnlyDigits.length === 11) {
          line.phone = `55${phoneOnlyDigits}`;
        }
        if (line.monthlyRevenueRange) {
          const found = MONTHLY_REVENUE_RANGE_DATA.find((r) => r.name === line.monthlyRevenueRange);
          line.monthlyRevenueRange = found ? found.code : line.monthlyRevenueRange;
        }
        if (line.occupation) {
          const found = occupations.find((o) => o.name === line.occupation);
          line.occupationName = found ? found.name : line.occupation;
          line.occupation = found ? found.id : line.occupation;
        }
      });

      if (uploadLines.length < 1) {
        return message.error(`${file.name} está vazio.`)
      }

      const newData = formatDataTable(uploadLines, data.data, true);
      setData((dataFetch) => ({ ...dataFetch, dataTable: newData }))
      setFilterRegister(newData);
      resetSelectionAndPage();

      setValidateFields(true);

    } catch (e) {
      return message.error(`Um erro ocorreu durante o upload do arquivo, tente novamente mais tarde ou comunique o administrador.`)
    } finally {
      setLoading(false);
    }
  }

  function isValidEmail(value) {
    const regex = /^[A-Za-z0-9._+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return regex.test(value);
  }

  const onUploadPreRegisterSheet = async (file) => {
    try {
      setImportShow(false);
      setLoading(true);
      setSaveData(false);

      const fileBuffer = await file.arrayBuffer();
      const workBook = read(fileBuffer, {
        cellDates: true
      });
      const workSheet = workBook.Sheets[workBook.SheetNames[0]];
      const uploadLines = utils.sheet_to_json(workSheet,
        {
          header: PRE_REGISTER_HEADERS.map(header => header.key),
        }
      );

      uploadLines.shift()

      if (uploadLines.length < 1) {
        return message.error(`${file.name} está vazio.`)
      }

      const newData = uploadLines.map((row, index) => {
        const hasPhone = row.phone && row.phone.toString().trim().length > 0;
        const hasEmail = row.email && row.email.toString().trim().length > 0;
        const validEmail = hasEmail ? isValidEmail(row.email): true;
        const errorMessage = (!hasPhone && !hasEmail)? 'Informe pelo menos um meio de contato: e-mail ou telefone' : hasEmail && !validEmail? 'Email inválido': '';

        if (!hasPhone && !hasEmail || !validEmail) {
          return {
            ...row,
            edited: true,
            message: '',
            errorField: {
              name: 'email',
              error: errorMessage
            },
            key: index,
            name: row.name && row.name.toString(),
            email: hasEmail ? row.email && row.email.toString() : '',
            cpf: formatCpfMask(row.cpf.toString().length < 11 ? row.cpf.toString().padStart(11, '0') : row.cpf.toString()),
            phone: hasPhone ? row.phone : '',
            campaign: row.campaign && row.campaign.toString(),
            autoIssueCorporateCard: row.autoIssueCorporateCard?.toString().toUpperCase() === "S",
            company: login.company.master ? company : login.company.id,
          }
        }

        const phoneOnlyDigits = row.phone ? row.phone.toString().replace(/\D/g, '') : '';
        if (phoneOnlyDigits.length === 11) {
          row.phone = `55${phoneOnlyDigits}`;
        }

        return {
          ...row,
          edited: true,
          message: '',
          errorField: null,
          key: index,
          name: row.name && row.name.toString(),
          email: row.email && row.email.toString(),
          cpf: formatCpfMask(row.cpf.toString().length < 11 ? row.cpf.toString().padStart(11, '0') : row.cpf.toString()),
          phone: row.phone || '',
          campaign: row.campaign && row.campaign.toString(),
          autoIssueCorporateCard: row.autoIssueCorporateCard?.toString().toUpperCase() === "S",
          company: login.company.master ? company : login.company.id,
        }
      });

      setTableData(newData);
      setFilterPreRegister(newData);
      resetSelectionAndPage();

      setValidateFields(true);

    } catch (e) {
      return message.error(`Um erro ocorreu durante o upload do arquivo, tente novamente mais tarde ou comunique o administrador.`)
    } finally {
      setLoading(false);
    }
  }

  const onOpenImport = () => {
    if (login.company.master && !company) return message.error(`Selecione uma empresa antes de continuar!`)
    setImportShow(true);
    const val = generateTemplateExcel().example(
      data.header
        .filter((d) => filterFieldsSelected(d.key))
        .map((d) => d.title),
      data.data,
      data.fields.filter((d) => filterFieldsSelected(d)),
      data.filter
    );
    formImport.setFieldsValue({
      inputData: val,
    });
  };

  const onChangeCompany = (company) => {
    onClearPreRegister();
    setCompany(company);
  };

  const loadOccupations = async () => {
    setOccupations(await getAllOccupationV2());
  }

  const filteredList = option === REGISTER ? filterRegister : filterPreRegister;
  const allFilteredSelected = filteredList.length > 0 && filteredList.every((d) => selectedRowKeys.includes(d.key));

  const onToggleSelectAll = () => {
    setSelectedRowKeys(allFilteredSelected ? [] : filteredList.map((d) => d.key));
    if (!saving) setSaveData(false);
  };

  const resetSelectionAndPage = () => {
    setSelectedRowKeys([]);
    setPagination((p) => ({ ...p, current: 1 }));
  };

  React.useEffect(() => {
    if (company || !login.company.master) loadCompany();
    loadOccupations();
  }, [company]);

  React.useEffect(() => {
    if (companyData) {
      searchForm.resetFields();
      load();
    }
  }, [companyData, option]);


  const getFieldsXls = () => {
    let headerNew = [...data.header];
    let fieldsNew = [...data.fields];
    if(visibleFields.includes("mother")) {
      headerNew.push({ title: "Nome da Mãe", key: "mother" });
      fieldsNew.push("mother");
    }
    if (companyData && companyData.enableCode) {
      headerNew.push({ title: "Código do participante", key: "code" });
      fieldsNew.push("code");
    }
    return { header: headerNew, fields: fieldsNew };
  };


  const load = async () => {
    try {
      const preRegister = option === PRE_REGISTER;
      setLoading(true);
      resetSelectionAndPage();
      const res = login.company.master
        ? await getAllEmployees({ company, preRegister })
        : await getAllEmployees({ preRegister });

      const formatData = res.map((user, index) => {
        if (option === REGISTER) {
          return {
            ...user,
            address: user.addressMap ? user.addressMap.address : null,
            number: user.addressMap ? user.addressMap.number : null,
            complement: user.addressMap ? user.addressMap.complement : null,
            zipcode: user.addressMap ? user.addressMap.zipcode : null,
            neighborhood: user.addressMap ? user.addressMap.neighborhood : null,
            city: user.addressMap ? user.addressMap.city : null,
            state: user.addressMap ? user.addressMap.state : null,
            key: index,
          };
        } else {

          const formattedUser = {
            key: index,
            name: user.name,
            id: user.id,
            campaign: user.campaign,
            cpf: formatCpfMask(user.cpf) || '',
            email: user.email || '',
            phone: user.phone || '',
            autoIssueCorporateCard: user.autoIssueCorporateCard ?? false,
          };

          return formattedUser;
        }
      });

      const baseFields = ['name', 'email', 'cpf', 'phone', 'campaign'];
      const fields = option === REGISTER ? getFieldsXls() : {
        fields: baseFields,
        header: PRE_REGISTER_HEADERS,
      }

      if (option === PRE_REGISTER) {
        setTableData(formatData);
        setFilterPreRegister(formatData);
      } else {
        setData((dataFetch) => ({
          ...dataFetch,
          data: formatData,
          dataTable: formatData,
          fields: fields.fields,
          header: fields.header,
        }));
        setFilterRegister(formatData);
      }

      setVisibleFields([
        ...fields.fields.filter(
          (field) =>
            field != "cpf" &&
            field != "number" &&
            field != "complement" &&
            field != "neighborhood" &&
            field != "zipcode" &&
            field != "city" &&
            field != "state"
        ),
        "card",
        "enabled",
      ]);
      setValidateFields(true);
      return formatData;
    } finally {
      setLoading(false);
    }
  };

  const loadCompany = async () => {
    setLoading(true);
    setCompanyData(
      login.company.master ? await getCompany(company) : login.company
    );
    setLoading(false);
  };

  const validFields = async () => {
    if (data.dataTable.length > 0) {
      try {
        let values = await form.validateFields();
      } catch (errIfo) {
        for (let val of errIfo.errorFields) {
          let split = val.name[0].split("_");
          let index = split[1];
          data.dataTable[index].status = ERROR_STATUS;
          data.dataTable[index].message = val.errors[0];
        }
        setData((dataFetch) => ({ ...dataFetch, dataTable: data.dataTable }));
      }
      setValidateFields(false);
    }
  };

  React.useEffect(() => {
    if (validateFields) {
      validFields();
    }
  }, [validateFields, data.dataTable]);

  const defaultColumns = [
    {
      title: "Nome",
      dataIndex: "name",
      width: 300,
      editable: true,
      required: true,
    },
    {
      title: "E-mail",
      dataIndex: "email",
      width: 250,
      editable: true,
      required: true,
    },
    {
      title: "CPF",
      dataIndex: "cpf",
      width: 165,
      editable: false,
      required: true,
      render: (value) => formatCpfMask(value),
    },
    {
      title: "Nascimento",
      dataIndex: "birthday",
      width: 140,
      editable: true,
      required: true,
      render: (value) => {
        return value ? formatDate(value, "DD/MM/YYYY") : "";
      },
    },
    {
      title: "Telefone",
      dataIndex: "phone",
      width: 170,
      editable: true,
      required: true,
    },
    {
      title: "Sexo",
      dataIndex: "sex",
      width: 70,
      required: true,
      editable: true,
    },
    {
      title: "Status",
      dataIndex: "enabled",
      width: 100,
      editable: true,
      required: true,
      render: (value) => (value ? "Ativo" : "Inativo"),
    },
    {
      title: "Cartão",
      dataIndex: "card",
      width: 100,
      editable: true,
      required: true,
      render: (value) => (value ? "Sim" : "Não"),
    },
    {
      title: "Endereço",
      dataIndex: "address",
      width: 250,
      required: true,
      editable: true,
    },
    {
      title: "Número",
      dataIndex: "number",
      width: 110,
      required: true,
      editable: true,
    },
    {
      title: "Complemento",
      dataIndex: "complement",
      width: 200,
      editable: true,
    },
    {
      title: "Bairro",
      dataIndex: "neighborhood",
      width: 150,
      required: true,
      editable: true,
    },
    {
      title: "CEP",
      dataIndex: "zipcode",
      width: 110,
      required: true,
      editable: true,
    },
    {
      title: "Cidade",
      dataIndex: "city",
      width: 130,
      required: true,
      editable: true,
    },
    {
      title: "Estado",
      dataIndex: "state",
      width: 80,
      required: true,
      editable: true,
    },
    {
      title: "Nome da Mãe",
      dataIndex: "mother",
      width: 80,
      required: false,
      editable: true,
    },
    {
      title: "País (BRA)",
      dataIndex: "country",
      width: 100,
      required: true,
      editable: true,
    },
    {
      title: "Ocupação",
      dataIndex: "occupation",
      width: 200,
      required: true,
      editable: true,
    },
    {
      title: "Faixa de renda mensal",
      dataIndex: "monthlyRevenueRange",
      width: 200,
      required: true,
      editable: true,
    }
  ];


  const defaultPreRegisterColumns = [
    {
      title: "Nome",
      dataIndex: "name",
      width: 300,
      editable: true,
      required: false,
      render: (value, record) => (
        <Input
          value={value}
          onChange={(e) => {
            handleSave({ ...record, name: e.target.value });
          }}
        />
      ),
    },
    {
      title: "E-mail",
      dataIndex: "email",
      width: 350,
      editable: true,
      required: false,
      render: (value, record) => (
        <Input
          value={value}
          onChange={(e) => {
            handleSave({ ...record, email: e.target.value });
          }}
        />
      ),
    },
    {
      title: "CPF",
      dataIndex: "cpf",
      width: 220,
      editable: true,
      required: true,
      render: (value) => (
        <Input
          disabled={false}
          value={formatCpfMask(value)}
        />
      ),
    },
    {
      title: "Telefone",
      dataIndex: "phone",
      width: 220,
      editable: true,
      required: false,
      render: (value, record) => (
        <Input
          value={value}
          onChange={(e) => {
            handleSave({ ...record, phone: e.target.value });
          }}
        />
      ),
    },
    {
      title: "Campanha / CNPJ",
      dataIndex: "campaign",
      width: 250,
      editable: true,
      required: false,
      render: (value, record) => (
        <Input
          value={value}
          onChange={(e) => {
            handleSave({ ...record, campaign: e.target.value });
          }}
        />
      ),
    },
    {
      title: "Corporativo (S/N)",
      dataIndex: "autoIssueCorporateCard",
      width: 140,
      editable: true,
      required: false,
    },
  ];

  const preRegisterColumns = defaultPreRegisterColumns.map((col) => {
    if (col.dataIndex === "status") {
      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: false,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave,
        }),
      };
    }

    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        inputType: getInputType(col.dataIndex),
        select: getSelect(col.dataIndex),
        required: col.required,
        handleSave,
      }),
    };
  });


  if (companyData && companyData.enableCode) {
    defaultColumns.push({
      title: "Código do participante",
      dataIndex: "code",
      width: 110,
      required: false,
      editable: true,
    });
  }

  if (saveData) {
    defaultColumns.splice(0, 0, {
      title: "",
      dataIndex: "status",
      width: 40,
      fixed: "left",
      align: "center",
      filters: [
        { text: "Sucesso", value: SUCCESS_STATUS },
        { text: "Salvando", value: SAVING_STATUS },
        { text: "Sem alteração", value: NOT_CHANGES_STATUS },
        { text: "Erro", value: ERROR_STATUS },
      ],
      onFilter: (value, record) => record.status === value,
    });

    preRegisterColumns.splice(0, 0, {
      title: "Status",
      dataIndex: "status",
      width: 100,
      fixed: "left",
      align: "center",
      filters: [
        { text: "Sucesso", value: SUCCESS_STATUS },
        { text: "Salvando", value: SAVING_STATUS },
        { text: "Sem alteração", value: NOT_CHANGES_STATUS },
        { text: "Erro", value: ERROR_STATUS },
      ],
      onFilter: (value, record) => record.status === value,
      render: (_, record) => {
        let message = record.message;
        let icon = "";
        if (record.status === SAVING_STATUS) {
          icon = <LoadingOutlined className="color-gray" />;
        } else if (record.status === ERROR_STATUS) {
          icon = <CloseCircleOutlined className="color-error" />;
        } else if (record.status === NOT_CHANGES_STATUS) {
          icon = <MinusCircleOutlined className="color-gray" />;
        } else if (record.status === SUCCESS_STATUS) {
          icon = <CheckCircleOutlined className="color-success" />;
        }
        return (
          <span style={{ marginLeft: 0 }}>
            <Tooltip title={message}>{icon}</Tooltip>
          </span>
        );
      }
    });

  }

  const handleSave = (updated) => {
    let invalid = false;
    const hasEmail = updated.email && updated.email.toString().trim().length > 0;
    const hasPhone = updated.phone && updated.phone.toString().trim().length > 0;
    const validEmail = hasEmail ? isValidEmail(updated.email): true;
    const errorMessage = (!hasPhone && !hasEmail)? 'Informe pelo menos um meio de contato: e-mail ou telefone' : hasEmail && !validEmail? 'Email inválido': '';
    const isValid = (!hasEmail && !hasPhone) || !validEmail;

    if (option === PRE_REGISTER && isValid) {
      updated.status = ERROR_STATUS;
      updated.errorField = {
        name: 'email',
        error: errorMessage,
      };
      invalid = true;
    } else {
      updated.errorField = null;
    }

    if(!invalid) {
      for (let row in updated) {
        const columns = option === REGISTER ? defaultColumns : preRegisterColumns;
        let col = columns.filter((d) => d.dataIndex == row);
        if (col.length > 0 && col[0].required && (updated[row] === "" || updated[row] === null)) {
          updated.status = ERROR_STATUS;
          updated.message = `${col[0].title} é um campo obrigatório!`;
          invalid = true;
          break;
        }
      }
    }

    if (!invalid && updated.status != ERROR_STATUS) {
      updated.status = option === REGISTER ? null : NOT_CHANGES_STATUS;
      updated.message = "";
      updated.errorField = null;
    }

    updated.edited = true;
    const newData = option === REGISTER ? [...data.dataTable] : [...tableData];
    const index = newData.findIndex((item) => updated.key === item.key);
    const old = newData[index];
    newData.splice(index, 1, { ...old, ...updated });

    if (option === REGISTER) {
      setData((dataFetch) => ({ ...dataFetch, dataTable: newData }));
      const index = filterRegister.findIndex((item) => item.key === updated.key);
      const newFilter = [...filterRegister];
      newFilter.splice(index, 1, { ...updated });
      setFilterRegister(newFilter);
    } else {
      setTableData(newData);
      const index = filterPreRegister.findIndex((item) => item.key === updated.key);
      const newFilter = [...filterPreRegister];
      newFilter.splice(index, 1, { ...updated });
      setFilterPreRegister(newFilter);

    }
    setLoading(false);
  };

  const getInputType = (dataIndex) => {
    if (dataIndex === "birthday") return "date";
    else if (
      dataIndex === "enabled" ||
      dataIndex === "sex" ||
      dataIndex === "card" ||
      dataIndex === "occupation" ||
      dataIndex === "monthlyRevenueRange" ||
      dataIndex === "autoIssueCorporateCard"
    )
      return "select";
    else if (dataIndex === "number") return "number";
    else if (dataIndex === "income") return "currency";
    return "text";
  };

  const getSelect = (dataIndex) => {
    if (dataIndex === "card")
      return [
        { label: "Sim", value: true },
        { label: "Não", value: false },
      ];
    if (dataIndex === "enabled")
      return [
        { label: "Ativo", value: true },
        { label: "Inativo", value: false },
      ];
    else if (dataIndex === "sex")
      return [
        { label: "M", value: "M" },
        { label: "F", value: "F" },
      ]
    else if (dataIndex === "occupation")
      return occupations.map((o) => ({ label: o.name, value: o.id }));
    else if (dataIndex === "monthlyRevenueRange")
      return MONTHLY_REVENUE_RANGE_DATA.map((r) => ({ label: r.name, value: r.code }));
    else if (dataIndex === "autoIssueCorporateCard")
      return [
        { label: "Não", value: false },
        { label: "Sim", value: true },
      ];
    return [];
  };

  const columns = defaultColumns
    .filter((d) => filterFieldsSelected(d.dataIndex) || d.dataIndex == "status")
    .map((col) => {
      if (!col.editable && col.dataIndex != "status") {
        return col;
      }

      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          inputType: getInputType(col.dataIndex),
          select: getSelect(col.dataIndex),
          required: col.required,
          handleSave,
        }),
      };
    });


  const saveAll = async () => {
    try {
      setSaveData(true);
      setSaving(true);
      setLoading(true);
      let saveList = [];
      for (let item of data.dataTable) {
        if (item.edited) {
          saveList.push(item);
          item.status = SAVING_STATUS;
          item.message = `Salvando dados...`;
        } else {
          item.status = NOT_CHANGES_STATUS;
          item.message = `Esse participante não teve alterações.`;
        }
      }
      setData((dataFetch) => ({ ...dataFetch, dataTable: data.dataTable }));
      const limit = pLimit(2);
      let promises = saveList.map((user) => {
        return limit(() => save(user));
      });
      await Promise.all(promises);
    } finally {
      setSaving(false);
      setLoading(false);
    }
  };

  const formatCpfMask = (cpf) => {
		if (!cpf) {
			return '';
		}
    const digits = cpf.toString().replace(/\D/g, '');
    if (digits.length === 11) {
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    return cpf.toString();
  };

  const formatPreRegisterBody = (user) => {
    const body = { ...user };
    delete body.status;
    delete body.message;
    delete body.errorField;
    delete body.key;
    delete body.edited;
    delete body.id;
    delete body._filterIndex;
    body.cpf = body.cpf.toString().replace(/\D/g, '');
    body.name = user.name || null;
    body.phone = user.phone && user.phone.toString().replace(/\D/g, '') || '';
    return body;
  }

  const onPreRegisterAll = async () => {
    try {
      setSaveData(true);
      setSaving(true);
      setLoading(true);

      const updatedTableData = filterPreRegister.map((user, idx) => {
        if (user.edited) {
          return {
            ...user,
            status: SAVING_STATUS,
            message: 'Salvando dados...',
            _filterIndex: idx,
          };
        } else {
          return {
            ...user,
            status: NOT_CHANGES_STATUS,
            message: 'Esse participante não teve alterações',
            _filterIndex: idx,
          }
        }
      });

			let saveList = updatedTableData.map((user, idx) => ({ ...user, _filterIndex: idx })).filter(user => user.edited);

      setTableData(updatedTableData);
      setFilterPreRegister(updatedTableData);

      const limit = pLimit(2);
      let promises = saveList.map((user) => {
        return limit(() => savePreRegister(user, updatedTableData, user._filterIndex));
      });
      await Promise.all(promises);
    } finally {
      setSaving(false);
      setLoading(false);
    }

  }

  const formatData = (item) => {
    let find = data.data.filter(
      (d) => formatCpf(d.cpf) === formatCpf(`${item.cpf}`)
    );

    let body = {
      id: find.length > 0 ? find[0].id : 0,
      name: emptyValue(item.name),
      email: emptyValue(item.email),
      cpf: emptyValue(formatCpf(`${item.cpf}`)),
      birthday: item.birthday ? moment(item.birthday).toDate() : null,
      phone: emptyValue(replacePhone(`${item.phone}`)),
      sex: emptyValue(item.sex),
      enabled: item.enabled,
      card: item.card,
      occupation: item.occupation,
      occupationName: occupations.find((o) => o.id === item.occupation)?.name || item.occupation,
      monthlyRevenueRange: item.monthlyRevenueRange
    };
    if (item.address !== "" && item.number !== "" && item.city !== "") {
      body.address = {
        address: emptyValue(item.address),
        number: emptyValue(item.number),
        complement: emptyValue(item.complement),
        zipcode: item.zipcode
          ? emptyValue(item.zipcode.toString().replace(/\D/g, ""))
          : null,
        neighborhood: emptyValue(item.neighborhood),
        city: emptyValue(item.city),
        state: emptyValue(item.state),
        country: emptyValue(item.country),
      };
    }
    if (login.company.master) {
      body.company = company;
    }
    if (companyData && companyData.enableCode) {
      body.code = emptyValue(item.code);
    }
    if(visibleFields.includes("mother")) {
      body.mother = item.mother;
    }
    body.fields = visibleFields;
    return body;
  };

  const validData = (item, itemClone) => {
    for (let key in item) {
      const column = option === REGISTER ? columns : preRegisterColumns;
      let col = column.filter((c) => c.dataIndex === key);
      if (col.length > 0 && col[0].required && emptyValue(item[key]) === null) {
        itemClone.status = ERROR_STATUS;
        itemClone.message = `${col[0].title} é obrigatório!`;
        return false;
      }
    }
    return true;
  };

  const updateFields = (fields) => {
    if(fields.includes("mother") && !visibleFields.includes("mother")) {
      data.header.push({ title: "Nome da Mãe", key: "mother" });
      data.fields.push("mother");
    } else {
      data.header = data.header.filter(item => item.key !== "mother");
      const indexToRemove = data.fields.indexOf("mother");
      if (indexToRemove > -1) {
        data.fields.splice(indexToRemove, 1);
      }
    }
  }

  const save = async (item) => {
    try {
      setLoading(true);
      let cloneData = [...data.dataTable];
      if (validData(item, cloneData[item.key])) {
        let body = formatData(item);

        if (body.id == 0) {
          for (let field of defaultColumns.filter((c) => c.required)) {
            if (
              !visibleFields.includes(field.dataIndex) &&
              field.dataIndex != "cpf" &&
              field.title != "Rua" &&
              field.dataIndex != "number" &&
              field.dataIndex != "complement" &&
              field.dataIndex != "neighborhood" &&
              field.dataIndex != "zipcode" &&
              field.dataIndex != "city" &&
              field.dataIndex != "state"
            ) {
              cloneData[item.key].status = ERROR_STATUS;
              cloneData[item.key].message = "Campo obrigatório não preenchido!";
              setData((dataFetch) => ({ ...dataFetch, dataTable: cloneData }));
              return;
            }
          }
        }
        let res = await saveUserBatch(body);
        if (res.success) {
          cloneData[item.key].status = SUCCESS_STATUS;
          cloneData[item.key].message = "Participante salvo com sucesso";
          cloneData[item.key].errorField = null;
          if (body.id == 0) {
            data.data.push(res.data);
          }
        } else {
          cloneData[item.key].status = ERROR_STATUS;
          cloneData[item.key].message = res.errorMessage;
          if (res.infos && res.infos.field) {
            cloneData[item.key].errorField = {
              name: res.infos.field,
              error: res.errorMessage,
            };
          }
        }
        setData((dataFetch) => ({ ...dataFetch, dataTable: cloneData }));
        setFilterPreRegister(cloneData);
      } else {
        setData((dataFetch) => ({ ...dataFetch, dataTable: cloneData }));
        setFilterPreRegister(cloneData);
      }
    } catch (e) {
      message.error("Um erro ocorreu ao tentar salvar as alterações, tente novamente mais tarde!")
    } finally {
      setLoading(false);
    }
  };

  const onClearPreRegister = () => {
    setLoading(true);
    setFilterPreRegister([]);
    setLoading(false);
  }

	const savePreRegister = async (user, updatedData, filterIndex) => {
		try {
			setLoading(true);
			let cloneData = [...updatedData];
			const idx = filterIndex !== undefined ? filterIndex : user.key;
			if (validData(user, cloneData[idx])) {
				const userID = user?.id || 0;
				const body = formatPreRegisterBody(user);
        let res = await savePreRegisterUserBatch({ userID: userID, user: body });
				if (res.success) {
					if (userID === 0 && res.data.id) {
						cloneData[idx].id = res.data.id;
					}
					cloneData[idx].status = SUCCESS_STATUS;
					cloneData[idx].message = "Participante salvo com sucesso";
					cloneData[idx].errorField = null;
				} else {
					cloneData[idx].status = ERROR_STATUS;
					cloneData[idx].message = res.errorMessage;
					if (res.infos && res.infos.field) {
						cloneData[idx].errorField = {
							name: res.infos.field,
							error: res.errorMessage,
						};
					}
				}
				setTableData(cloneData);
				setFilterPreRegister(cloneData);
			} else {
				setTableData(cloneData);
				setFilterPreRegister(cloneData);
			}
		} catch (e) {
			message.error("Um erro ocorreu ao tentar salvar as alterações, tente novamente mais tarde!")
		} finally {
			setLoading(false);
		}
	};

  const activeAll = (status) => {
    let fields = {};
    data.dataTable
      .filter((d) => selectedRowKeys.includes(d.key))
      .map((d) => {
        d.enabled = status;
        d.edited = true;
        fields["enabled_" + d.key] = status;
      });
    form.setFieldsValue(fields);
    setData((dataFetch) => ({ ...dataFetch, dataTable: data.dataTable }));
    setSelectedRowKeys([]);
  };

  const card = () => {
    let fields = {};
    data.dataTable
      .filter((d) => selectedRowKeys.includes(d.key))
      .map((d) => {
        d.card = true;
        d.edited = true;
        fields["card_" + d.key] = true;
      });
    form.setFieldsValue(fields);
    setData((dataFetch) => ({ ...dataFetch, dataTable: data.dataTable }));
    setSelectedRowKeys([]);
  };
  const getAddresses = async () => {
    let fields = {};
    setSaveData(true);
    await Promise.all(
      data.dataTable
        .filter((d) => selectedRowKeys.includes(d.key))
        .map(async (d) => {
          try {
            const {
              bairro,
              localidade,
              logradouro,
              uf: estado,
            } = await httpGeo.getCep(d.zipcode);
            fields["address_" + d.key] = logradouro;
            d.address = logradouro;
            fields["neighborhood_" + d.key] = logradouro;
            d.neighborhood = bairro;
            fields["city_" + d.key] = localidade;
            d.city = localidade;
            fields["state_" + d.key] = estado;
            d.state = estado;
            d.country = "BRA";

            form.setFieldsValue(fields);

            data.dataTable[d.key].status = SUCCESS_STATUS;
            data.dataTable[d.key].message = "Endereço encontrado com sucesso";
            setSelectedRowKeys([]);
          } catch (e) {
            data.dataTable[d.key].status = ERROR_STATUS;
            data.dataTable[d.key].message = e.message;

            notification.error({
              message: e.message,
            });
          } finally {
            setData((dataFetch) => ({ ...dataFetch, dataTable: data.dataTable }));
          }
        })
    );

    setSelectedRowKeys([]);
  };

	const onSendFirstAccessNotification = async () => {
		if (option === REGISTER) {
			setShowFirstAccessNotification(false);
			return;
		}

		setSaving(true);
		setLoading(true);
		try {
			const userIDs = tableData
				.filter((item) => selectedRowKeys.includes(item.key))
				.map((item) => item.id)
				.filter(Boolean);

      const limit = pLimit(2);
      let promises = userIDs.map((userID) => {
        return limit(() => sendFirstAccessNotification(userID));
      });
      const results = await Promise.all(promises);
			const failed = results.filter((result) => !result || result.success === false);
			if (failed.length > 0) {
				notification.error({
					message: `Não foi possível enviar ${failed.length} de ${userIDs.length} ${userIDs.length > 1 ? "notificações" : "notificação"}.`,
					description: failed[0]?.errorMessage,
				});
			} else {
				notification.success({
					message: `${userIDs.length > 1 ? "Notificações enviadas" : "Notificação enviada"} com sucesso!`,
				});
			}
		} catch (e) {
			notification.error({
				message: "Ops! Ocorreu um erro ao enviar a notificação.",
				description: e.message,
			})
		} finally {
			setSaving(false);
			setLoading(false);
			setShowFirstAccessNotification(false);
		}
	}

  const sendPassword = async () => {
    setPasswordShow(false);
    setSaving(true);
    let saveList = [];
    for (let item of data.dataTable) {
      if (selectedRowKeys.includes(item.key)) {
        saveList.push(item);
        item.status = SAVING_STATUS;
        item.message = `Enviando e-mail de definição de senha...`;
      } else {
        item.status = NOT_CHANGES_STATUS;
        item.message = `Esse participante não teve alterações.`;
      }
    }
    setData((dataFetch) => ({ ...dataFetch, dataTable: data.dataTable }));
    setSelectedRowKeys([]);

    for (let i = 0; i < saveList.length; i++) {
      await saveListPass(saveList[i]);
    }
    setSaving(false);
  };

  const saveListPass = async (item) => {
    await savePasswordUser(item.id, true, false);
    data.dataTable[item.key].status = SUCCESS_STATUS;
    data.dataTable[item.key].message = "Email Enviado com sucesso";
    data.dataTable[item.key].errorField = null;
    setData((dataFetch) => ({ ...dataFetch, dataTable: data.dataTable }));
  };

  const getStatusName = (status) => {
    if (status === ERROR_STATUS) {
      return "Erro";
    } else if (status === SUCCESS_STATUS) {
      return "Sucesso";
    }
    if (status === SAVING_STATUS) {
      return "Salvando";
    }
    if (status === NOT_CHANGES_STATUS) {
      return "Sem alterações";
    }
    return "";
  };

  const prepareFileErrors = () => {
    let ws_data = [];

    const userList = option === REGISTER ? data.dataTable : tableData;

    userList.forEach((row) => {
      let error_body = {
        Nome: row.name && row.name,
        Email: row.email && row.email,
        CPF: row.cpf && row.cpf,
      };

      if (option === REGISTER) {
        error_body = {
          ...error_body,
          Nascimento:
            row.birthday && row.birthday !== ""
              ? moment(row.birthday).format("DD/MM/YYYY")
              : "",
          Telefone: row.phone,
          Sexo: row.sex,
          Rua: row.address,
          Número: row.number,
          Complemento: row.complement,
          Bairro: row.neighborhood,
          CEP: row.zipcode,
          Cidade: row.city,
          Estado: row.state,
          "País (BRA)": row.country,
          "Ocupação": row.occupation,
          "Faixa de renda mensal": row.monthlyRevenueRange,
          ...(visibleFields.includes("mother")) && {
            "Nome da Mãe": row.mother,
          },
          ...((login.company.master || login.company.enableCode) && {
            "Código do Participante": row.code,
          }),
          Status: getStatusName(row.status),
          ...(login.company.master && { Empresa: companyData.name }),
        };
      } else {
        error_body = {
          ...error_body,
          "Campanha / CNPJ": row.campaign && row.campaign,
        };
      }

      error_body = {
        ...error_body,
        Erros: row.message,
      };

      ws_data.push(error_body);
    });
    return ws_data;
  };

  const exportErrors = () => {
    saveFileResume(prepareFileErrors(), option === REGISTER ? "Exportaçao" : `resultado_pre_cadastro`, "Exportacao");
  };

  const onExportPreRegister = () => {
    const rows = tableData
      .filter((d) => selectedRowKeys.includes(d.key))
      .map((row) => ({
        Nome: row.name || "",
        "E-mail": row.email || "",
        CPF: row.cpf || "",
        Telefone: row.phone || "",
        "Campanha / CNPJ": row.campaign || "",
        "Corporativo (S/N)": row.autoIssueCorporateCard ? "S" : "N",
      }));

    const workSheet = utils.json_to_sheet(rows);
    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, workSheet, "pre_cadastro");
    writeFile(workBook, `pre_cadastro_${login.company.master ? companyData.name : login.company.name}.xlsx`);
  };

  const getWidth = () => {
    if (option === REGISTER) {
      return columns.length <= 6 ? null : 3000;
    }

    return defaultPreRegisterColumns.length <= 6 ? null : 1000;
  };

  const onDownloadPreRegisterExample = () => {
    const baseData = {
      Nome: "",
      "E-mail": "",
      CPF: "",
      Telefone: "",
      "Campanha / CNPJ": "",
      "Corporativo (S/N)": "",
    }

    const workSheet = utils.json_to_sheet([baseData]);

    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, workSheet, "pre_cadastro");
    writeFile(workBook, `pre_cadastro_${login.company.master ? companyData.name : login.company.name}.xlsx`);

  }

  // const onDownloadRegisterExample = () => {
  //   const baseData = {
  //     "Nome": "",
  //     "E-mail": "",
  //     "CPF": "",
  //     "Nascimento": "",
  //     "Telefone": "",
  //     "Sexo (M/F)": "",
  //     "Rua": "",
  //     "Número": "",
  //     "Complemento": "",
  //     "Bairro": "",
  //     "CEP": "",
  //     "Cidade": "",
  //     "Estado": ""
  //   }
  //   if(companyData && companyData.enableCode) {
  //     baseData["Código do participante"] = "";
  //   }

  //   if(visibleFields.includes("mother")) {
  //     baseData["Nome da Mãe"] = ""
  //   }

  //   const workSheet = utils.json_to_sheet([baseData]);

  //   const workBook = utils.book_new();
  //   utils.book_append_sheet(workBook, workSheet, "cadastro");
  //   writeFile(workBook, `upload_model_example.xlsx`);

  // }

  const onDownloadRegisterExample = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("cadastro");
    const listSheet = workbook.addWorksheet("listas");
    listSheet.state = "veryHidden";

    const columns = [
      "Nome",
      "E-mail",
      "CPF",
      "Nascimento",
      "Telefone",
      "Sexo (M/F)",
      "Rua",
      "Número",
      "Complemento",
      "Bairro",
      "CEP",
      "Cidade",
      "Estado",
      "País (BRA)",
      "Ocupação",
      "Faixa de renda mensal"
    ];

    if (companyData?.enableCode) {
      columns.push("Código do participante");
    }
    if (visibleFields.includes("mother")) {
      columns.push("Nome da Mãe");
    }
    worksheet.addRow(columns);
    occupations.forEach((occupation, index) => {
      listSheet.getCell(`A${index + 1}`).value = occupation.name;
    });
    MONTHLY_REVENUE_RANGE_DATA.forEach((range, index) => {
      listSheet.getCell(`B${index + 1}`).value = range.name;
    });

    for (let i = 2; i <= 1000; i++) {
      worksheet.getCell(`F${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"M,F"']
      };
    };

    for (let i = 2; i <= 1000; i++) {
      worksheet.getCell(`O${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`listas!$A$1:$A$${occupations.length}`]
      };
    };

    for (let i = 2; i <= 1000; i++) {
      worksheet.getCell(`P${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`listas!$B$1:$B$${MONTHLY_REVENUE_RANGE_DATA.length}`]
      };
    };

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer]),
      "upload_model_example.xlsx"
    );
  };


  const performDeletePreRegister = async (userID, userIndex) => {
    try {
      const response = await deletePreRegisterUserBatch(userID);
      if (response.success) {
        const updatedTableData = [...tableData];
        updatedTableData.splice(userIndex, 1);
        setTableData(updatedTableData);

        const updatedSelectedRowKeys = selectedRowKeys.filter(key => key !== userIndex);
        setSelectedRowKeys(updatedSelectedRowKeys);
      } else {
        notification.error({
          message: response.errorMessage,
        });
      }
    } catch (error) {
      notification.error({
        message: 'Erro ao excluir o pré-cadastro.',
      });
    }
  };

  const onDeletePreRegister = async () => {
    try {
      setShowDelete(false);
      setSaveData(true);
      setSaving(true);
      setLoading(true);
      const userIdsToDelete = [];

      for (let index of selectedRowKeys) {
        tableData[index].status = SAVING_STATUS;
        tableData[index].message = 'Excluindo dados...';
        userIdsToDelete.push({ userID: tableData[index].id, userIndex: index });
      }

      const limit = pLimit(2);
      const promises = userIdsToDelete.map(user => limit(() => performDeletePreRegister(user.userID, user.userIndex)));

      await Promise.all(promises);
      setSelectedRowKeys([]);
      const reloaded = await load();
      const term = searchForm.getFieldValue("filterValue");
      if (reloaded && term) setFilterPreRegister(applyFilter(reloaded, term));
    } finally {
      setSaveData(false);
      setSaving(false);
      setLoading(false);
    }
  };

	const normalize = (str) => (str || "").toLowerCase().normalize("NFKD").replace(/\p{Diacritic}/gu, "").trim();

  const applyFilter = (list, value) => {
    if (!value || value.trim().length === 0) return list;

    const lowercasedValue = value.toLowerCase();
    const onlyDigitsDocument = value.replace(/\D/g, "");
    return list.filter((userData) => {
			const name = normalize(userData.name);
			const email = normalize(userData.email);
			const campaign = normalize(userData.campaign);
			const cpf = (userData?.cpf || "").replace(/[^\d]/g, "").trim();

			return (
				name.includes(lowercasedValue) ||
				email.includes(lowercasedValue) ||
				campaign.includes(lowercasedValue) ||
				(onlyDigitsDocument.length && cpf.startsWith(onlyDigitsDocument))
			);
    });
  };

  const onFilter = async (value) => {
    setLoading(true);
    resetSelectionAndPage();
    try {
			if (!value) {
				await load();
				return;
			}

      const selectedData = option === REGISTER ? data.dataTable : tableData;
      const filteredEmployees = applyFilter(selectedData, value);

      option === REGISTER ? setFilterRegister(filteredEmployees) : setFilterPreRegister(filteredEmployees);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="alymente-layout">
      <Header
				title={"Pessoa Física"}
        subtitle={"Selecione os participantes para fazer ações em lote."}
        middle={
          login.company.master ? (
            <AutoCompleteCompany disabled={saving} value={company} onChange={onChangeCompany} />
          ) : undefined
        }
        routes={[{ label: "Importar Dados", button: true }]}
        onSelectRoute={() => onOpenImport()}
      >
        {selectedRowKeys.length > 0 && option === REGISTER ? (
          <div style={{ marginLeft: -15 }}>
            <Button type={"text"} onClick={() => setPasswordShow(true)}>
              Enviar senha do aplicativo
            </Button>
            <Button type={"text"} onClick={() => activeAll(false)}>
              Inativar
            </Button>
            <Button type={"text"} onClick={() => activeAll(true)}>
              Ativar
            </Button>
            <Button type={"text"} onClick={() => card()}>
              Cartão Entregue
            </Button>
            <Button type={"text"} onClick={getAddresses}>
              Consultar Endereços
            </Button>
          </div>
        ) : null}

        {
					selectedRowKeys.length > 0 && option === PRE_REGISTER ? (
						<Row style={{ gap: 10 }}>
							<div>
								<Button type={"text"} onClick={() => setShowFirstAccessNotification(true)}>
									Enviar notificação 1° acesso
								</Button>
							</div>

							<div>
								<Button type={"text"} onClick={() => setShowDelete(true)}>
									Excluir Participantes
								</Button>
							</div>

							<div>
								<Button type={"text"} onClick={onExportPreRegister}>
									Exportar Pré-Cadastros
								</Button>
							</div>
						</Row>
					) : null
				}
      </Header>
      <Content>

        <Row justify='center' style={{ marginBottom: 20 }}>
          <Radio.Group
            disabled={loading || saving}
            options={[
              { label: 'Cadastro Completo', value: REGISTER },
              { label: 'Pré-Cadastro', value: PRE_REGISTER },
            ]}
            onChange={(event) => {
              setSelectedRowKeys([]);
              setSaveData(false);
              setSaving(false);
              setOption(event.target.value);
            }}
            value={option}
            optionType="button"
            buttonStyle="solid"
          />
        </Row>
        {option === REGISTER ?
          <Row align="bottom" justify="space-between" style={{ marginBottom: 10 }}>
            <Col span={8} style={{ textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
              <Typography.Text>
                Selecionados: {selectedRowKeys.length}/{filterRegister.length}
              </Typography.Text>
              <Button
                style={{ marginRight: 10, maxWidth: 150 }}
                size="small"
                type={"primary"}
                disabled={loading}
                onClick={onToggleSelectAll}
              >
                {allFilteredSelected ? "Limpar Seleção" : "Selecionar Todos"}
              </Button>
            </Col>
            <Col span={8} style={{ textAlign: 'center' }}>
              <Form
                name="basic"
                form={searchForm}
                onFinish={(values) => {
                  onFilter(values.filterValue || '');
                }}
              >
                <Form.Item
                  name="filterValue"
                >
                  <Search
                    onSearch={onFilter}
                    placeholder="Nome, CPF ou Empresa"
                    allowClear={false}
                    disabled={loading}
                    suffix={
                      !loading && (<Tooltip title="Limpar Pesquisa">
                        <CloseCircleOutlined
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            searchForm.resetFields();
                            onFilter('');
                          }}
                        />
                      </Tooltip>)
                    }
                  />
                </Form.Item>
              </Form>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <CheckboxMenu
                options={defaultColumns.filter(
                  (v) =>
                    v.dataIndex != "cpf" &&
                    v.dataIndex != "number" &&
                    v.dataIndex != "complement" &&
                    v.dataIndex != "neighborhood" &&
                    v.dataIndex != "zipcode" &&
                    v.dataIndex != "city" &&
                    v.dataIndex != "state"
                )}
                value={visibleFields}
                onChange={(values) => {
                  setVisibleFields(values);
                  updateFields(values);
                }}
              >
                <Button size="small" type={"primary"}>
                  Escolher Campos Editáveis
                </Button>
              </CheckboxMenu>
            </Col>
          </Row>
          :
          <Row align="bottom" style={{ marginBottom: 10 }}>
            <Col span={8} style={{ textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
              {
                tableData.filter(user => user.id).length > 0 && <>
                  <Typography.Text>
                    Selecionados: {selectedRowKeys.length}/{filterPreRegister.length}
                  </Typography.Text>
                  <Button
                    style={{ marginRight: 10, maxWidth: 150 }}
                    size="small"
                    type={"primary"}
                    disabled={loading || saving}
                    onClick={onToggleSelectAll}
                  >
                    {allFilteredSelected ? "Limpar Seleção" : "Selecionar Todos"}
                  </Button>

                </>

              }
            </Col>

            <Col span={8} style={{ textAlign: 'center' }}>
              <Form
                name="basic"
                form={searchForm}
              >
                <Form.Item
                  name="filterValue"
                >
                  <Search
                    onSearch={onFilter}
                    placeholder="Nome, CPF ou Empresa"
                    allowClear={false}
                    disabled={loading}
                    suffix={
                      !loading && (<Tooltip title="Limpar Pesquisa">
                        <CloseCircleOutlined
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            searchForm.resetFields();
                            onFilter('');
                          }}
                        />
                      </Tooltip>)
                    }
                  />
                </Form.Item>
              </Form>
            </Col>

            <Col span={8} style={{ textAlign: 'right' }}>
              {
                tableData.length > 0 && <>
                  <Button
                    size="small"
                    type={"primary"}
                    disabled={loading || saving}
                    onClick={() => {
                      Modal.confirm({
                        title: "Confirmação",
                        content: `Deseja excluir os itens "Nome", "E-mail", "CPF", "Campanha / CNPJ" e "Valor da Carga" da tabela?`,
                        okText: "Sim",
                        cancelText: "Não",
                        onOk: () => onClearPreRegister(),
                      })
                    }}
                  >
                    Limpar Tabela
                  </Button>

									<Button
										style={{ marginLeft: 10 }}
										size="small"
										type={"primary"}
										disabled={loading || saving}
										onClick={() => {
											searchForm.resetFields();
											load();
										}}
									>
										Carregar Todos
									</Button>
                </>
              }
            </Col>

          </Row>
        }

        <TableForm
          bordered
          dataSource={option === REGISTER ? filterRegister : filterPreRegister}
          columns={option === REGISTER ? columns : preRegisterColumns}
          scroll={{ x: getWidth(3000), y: 450 }}
          form={form}
          onChangeRowSelect={setSelectedRowKeys}
          selectedRowKeys={selectedRowKeys}
          selectRows={option === REGISTER ? !saveData : !saveData && filterPreRegister.filter(user => user.id).length > 0}
          loading={loading}
          pagination={{
            ...pagination,
            showSizeChanger: true,
            pageSizeOptions: [10, 20, 50, 100],
            showTotal: (total) => `${total} registros`,
            onChange: (current, pageSize) => setPagination({ current, pageSize }),
          }}
        />

        <Row
          style={{
            marginTop: 20
          }}
        >
          <Col
            sm={8}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <Button
              disabled={loading || (option === REGISTER ? data.dataTable.filter((d) => d.status).length === 0 : tableData.filter((d) => d.status && d.status !== NOT_CHANGES_STATUS && d.status !== SAVING_STATUS).length === 0)}
              style={{ marginRight: 10 }}
              size="small"
              type={"primary"}
              onClick={() => exportErrors()}
            >
              Exportar Resultado
            </Button>
            <Typography.Text style={{ marginRight: 15 }}>
              Sucesso:{" "}
              {
                option === REGISTER ?
                  data.dataTable.filter((d) => d.status === SUCCESS_STATUS).length :
                  tableData.filter((d) => d.status === SUCCESS_STATUS).length
              }
            </Typography.Text>
            <Typography.Text>
              Erro: {
                option === REGISTER ?
                  data.dataTable.filter((d) => d.status === ERROR_STATUS).length :
                  tableData.filter((d) => d.status === ERROR_STATUS).length
              }
            </Typography.Text>
          </Col>
        </Row>
      </Content>
      <Footer style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
      }}>
        <Button
          className="btn-save"
          type="primary"
          onClick={() => navigate(`/user`)}>
          Voltar
        </Button>
        {
          option === REGISTER ?
            <Button
              disabled={
                loading || saving || (login.company.master && !company) || data.dataTable.length === 0 || data.dataTable.filter(user => user.edited).length === 0
              }
              loading={loading}
              className="btn-save"
              type="primary"
              icon={<SaveOutlined />}
              onClick={() => saveAll()}
            >
              Salvar
            </Button>
            :
            <Button
              disabled={
                loading || saving || (login.company.master && !company) || tableData.length === 0 || tableData.filter(user => user.edited).length === 0
              }
              loading={saving}
              className="btn-save"
              type="primary"
              icon={<SaveOutlined />}
              onClick={() => onPreRegisterAll()}
            >
              Salvar
            </Button>
        }
      </Footer>
      <Modal
        width={1000}
        open={importShow}
        title={option === REGISTER ? "Importação de Participantes" : "Pré-cadastro em massa"}
        onCancel={() => setImportShow(false)}
        footer={[]}
      >
        {
          <Row>
            <Col span={24}>
              <Spin spinning={loading || saving}>
                <Dragger
                  name="file_uploaded"
                  multiple={false}
                  showUploadList={false}
                  accept=".xls, .xlsx, .ods"
                  beforeUpload={async (file, _) => {
                    if (option === REGISTER) {
                      await onUploadSheet(file);
                    } else {
                      await onUploadPreRegisterSheet(file);
                    }
                    return false;
                  }}>
                  <p className="ant-upload-drag-icon">
                    <UploadOutlined />
                  </p>
                  <p className="ant-upload-drag-text">
                    Clique aqui ou arraste sua planilha para fazer upload
                  </p>
                  <p className="ant-upload-drag-hint">
                    Arquivo deve ter extensão .xls, .xlsx ou .ods
                  </p>
                </Dragger>
                {option === REGISTER ?
                  <p style={linkStyle} onClick={() => onDownloadRegisterExample()}>
                      Baixar arquivo de cadastro
                  </p>
                  : <Col span={24} style={{ margin: '14px 0px' }}>
                    <Typography.Text
                      style={{ fontWeight: 'normal', marginLeft: '10px', userSelect: 'none', cursor: 'pointer' }}
                    >
                      <p style={linkStyle} onClick={() => onDownloadPreRegisterExample()}>Baixar arquivo de pré-cadastro</p>.
                    </Typography.Text>
                  </Col>
                }
              </Spin>
            </Col>
          </Row>
        }
      </Modal>
      <Modal
        open={passwordShow}
        title="Confirmação"
        onOk={sendPassword}
        onCancel={() => setPasswordShow(false)}
        style={{ textAlign: "center" }}
      >
        <Typography.Text style={{ textAlign: "center" }}>
          Deseja enviar e-mail para definição de senha do aplicativo para{" "}
          {selectedRowKeys.length} participantes?
        </Typography.Text>
      </Modal>

      <Modal
        open={showFirstAccessNotification}
        title="Reenviar notificação de primeiro acesso"
				okText="Reenviar"
				okButtonProps={{ loading: loading, disabled: loading || selectedRowKeys.length === 0 }}
				cancelButtonProps={{ disabled: loading }}
        onOk={onSendFirstAccessNotification}
        onCancel={() => setShowFirstAccessNotification(false)}
        style={{ textAlign: "center" }}
      >
        <Typography.Text style={{ textAlign: "center" }}>
          Deseja reenviar e-mail/sms de notificação de primeiro acesso para{" "} {selectedRowKeys.length} participante(s)?
        </Typography.Text>
      </Modal>

      <Modal
        open={showDelete}
        title="Confirmação"
        onOk={() => onDeletePreRegister()}
        onCancel={() => setShowDelete(false)}
        style={{ textAlign: "center" }}
      >
        <Typography.Text style={{ textAlign: "center" }}>
          Deseja excluir {selectedRowKeys.length} {selectedRowKeys.length > 1 ? "pré-cadastros" : "pré-cadastro"}?
        </Typography.Text>
        <br />
        <Typography.Text style={{ textAlign: "center" }}>
          O dinheiro retornará para a conta da empresa.
        </Typography.Text>
      </Modal>
    </Layout>
  );
};

export default connect(mapStateToProps, {})(UserBatchScreen);
